const rupiahFormatter = new Intl.NumberFormat("id-ID", {
  style: "currency",
  currency: "IDR",
  maximumFractionDigits: 0,
});

const dateFormatter = new Intl.DateTimeFormat("id-ID", {
  day: "numeric",
  month: "long",
  year: "numeric",
  timeZone: "Asia/Jakarta",
});

const timeFormatter = new Intl.DateTimeFormat("id-ID", {
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
  timeZone: "Asia/Jakarta",
  timeZoneName: "short",
});

export function formatRupiah(amount: number): string {
  return rupiahFormatter.format(amount);
}

export function formatDate(isoDate: string): string {
  return dateFormatter.format(new Date(isoDate));
}

/** e.g. "23 Oktober 2026 · 14.05 WIB". */
export function formatDateTime(isoDate: string): string {
  const date = new Date(isoDate);
  return `${dateFormatter.format(date)} · ${timeFormatter.format(date)}`;
}

/** Whole-percent discount, e.g. 179000 → 49500 = 72. */
export function discountPercent(normalPrice: number, price: number): number {
  if (normalPrice <= 0 || price >= normalPrice) return 0;
  return Math.round(((normalPrice - price) / normalPrice) * 100);
}
